import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { AuthHttpInterceptor } from '@services/auth/auth.http.interceptor';

// services
import { WalletsService } from './wallets.service';

@NgModule({
  imports: [HttpClientModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptor,
      multi: true,
    },
  ],
})
export class WalletsServiceModule {
  static forRoot(): ModuleWithProviders<WalletsServiceModule> {
    return {
      ngModule: WalletsServiceModule,
      providers: [WalletsService],
    };
  }
}
